import { Outlet } from "react-router-dom";

// Styles
import styles from "./Layout.module.scss";
import Header from "@/components/Header/Header";

const Layout = () => {
  return (
    <div className={`App ${styles.layoutContainer}`}>
      {/*<Header />*/}
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
